import axios from "../utils/axios";

const API_URL = process.env.REACT_APP_API_URL + "/v1/admin";

const getLogs = (pageNo = 0, pageSize = 5, date = null) => {
    const params = new URLSearchParams({
        pageNo,
        pageSize
    });

    if (date instanceof Date) {
        // Format date as YYYY-MM-DD (ISO format)
        params.append('date', date.toISOString().split('T')[0]);
    } else if (typeof date === 'string' && date) {
        // If it's already a string, use it directly
        params.append('date', date);
    }

    return axios.get(`${API_URL}/scheduler-logs?${params}`);
};

const logsService = {
    getLogs
};

export default logsService;